import $ from 'jquery'

var explainOverlay = function($element) {

  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      $learnMoreLink,
      $explainOverlay;

  // constructor
  function init() {
    $explainOverlay = $('.explain-ace-overlay', $mainContainer);
    $learnMoreLink = $('.ace-marketing__learn-more', $mainContainer);

    bindDomEvents();
  }

  /* PRIVATE METHODS */

  function bindDomEvents() {

    $learnMoreLink.on('click', function(e) {
      e.preventDefault();
      showExplainOverlay($explainOverlay, $(this));
    });

    $('a:first', $explainOverlay).on('keydown', function(e) {
      if (e.keyCode == $.ui.keyCode.TAB && e.shiftKey) {
        e.preventDefault();
        SOPHIA.closeOverlayBox();
      }
    });
  }

  function showExplainOverlay(html, focus) {
    SOPHIA.overlayBox(html, {
      afterLoad: () => {
        $('.explain-ace-invisible-link').trigger('focus');
        $('.explain-ace-invisible-link').on('keydown', function(e){
          if (e.keyCode == $.ui.keyCode.TAB && e.shiftKey) {
            e.preventDefault();
            SOPHIA.closeOverlayBox();
          }
        });
      }
    }, focus);
  }

  // run constructor
  init();

  /* PUBLIC METHODS */

  return {
    // public methods go here
  };
}

// jQuery plugin method
$.fn.explainOverlay = function() {
  return this.each(function() {
    var $this = $(this);

    // If not already stored, store plugin object in this element's data
    if (!$this.data('explainOverlay')) {
      $this.data('explainOverlay', explainOverlay($this));
    }
  });
};
